var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("fiscal-years-select", {
        attrs: { fiscalYears: _vm.form.fiscalyears },
        on: {
          updateFiscalYears: _vm.updateFiscalYears,
          loaded: function($event) {
            return _vm.$emit("updateLoading", { loading: false })
          }
        }
      }),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "aright mt-5" },
        [
          _c("CompassButton", {
            attrs: {
              label: _vm.$t.__("common.actions.cancel"),
              type: "secondary"
            },
            on: { click: _vm.close }
          }),
          _vm._v(" "),
          _c("CompassButton", {
            attrs: { label: _vm.$t.__("common.actions.save"), type: "primary" },
            on: { click: _vm.submitForm }
          })
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }